import { MenuCommonService } from './../../../services/shared/menu-common.service';
import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { AnalyticsService, EventService } from 'smarthub-core';
import { Router, NavigationStart } from '@angular/router';
import * as Mustache from 'mustache';

declare var $: any;

import {
	ProfileService,
	NotificationService,
	SmartHubCoreInterfaceService,
} from 'smarthub-core';

@Component({
	selector: 'ngx-header',
	styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    // encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit, OnDestroy {
	@Input() position = 'normal';
    intervalRefreshToken: any;

    headerTemplateLeft = ``;
    headerTemplateRight = ``;
    notificationAmount = 0;

	constructor(
		private sidebarService: NbSidebarService,
		private menuService: NbMenuService,
		private nbMenuService: NbMenuService,
		private analyticsService: AnalyticsService,
		public _notify: NotificationService,
        public _profile: ProfileService,
        private _eventService: EventService,
		public _menu_common: MenuCommonService,
		private themeService: NbThemeService,
		private _router: Router,
		private _sh_interface: SmartHubCoreInterfaceService, // required for initializing
	) {
        this._sh_interface.init();
    }

    /**
     * based on team.template.header
     * will render left and right header using mustache and db template
     * If not defined will set variables to '', so we will render default value in html template
     * 
     * We render left and right header, passing userTeam as context (team loaded for this user from DB)
     */
    private renderHeaderTemplates() {
        const _template = this._profile.userTeam.template;
        // rendering left template
        if (_template.header_left) {
            this.headerTemplateLeft = Mustache.render(_template.header_left, this._profile.userTeam);
        } else {
            this.headerTemplateLeft = '';
        }
        // rendering right template
        if (_template.header_right) {
            this.headerTemplateRight = Mustache.render(_template.header_right, this._profile.userTeam);
        } else {
            this.headerTemplateRight = '';
        }
    }

	ngOnInit() {
		this._profile.getProfile(true).then(res => {
			this.changeTheme();
		});
		this.nbMenuService.onItemClick().subscribe(el => {
			el.item['fn']();
		});

		this._router.events.subscribe(ev => {
			if (ev instanceof NavigationStart) {
				if ($('nb-sidebar.expanded').length) {
					this.toggleSidebar();
				}
			}
        });
        this.retrieveEvents();
	}

	ngOnDestroy() {}

	changeTheme() {
		if (this._profile && this._profile.userProfile) {
            this.renderHeaderTemplates();
            const theme_name = this._profile.userTeam && this._profile.userTeam.theme ?
                               this._profile.userTeam.theme : this._profile.userTeamName;
            console.log(`loading theme: ${theme_name}`);
            if (theme_name !== 'lantern') {
				// lantern is the default theme
				this.themeService.changeTheme(theme_name);
			}
		}
	}

	toggleSidebar(): boolean {
        this.sidebarService.toggle(true, 'menu-sidebar');
        // this.layoutService.changeLayoutSize(); // TODO: use this mofo
		return false;
	}

	toggleSettings(): boolean {
		this.sidebarService.toggle(false, 'settings-sidebar');
		return false;
	}

	goToHome() {
		this.menuService.navigateHome();
    }
    
    retrieveEvents() {
		this._eventService.getEvents(null,null,'asc',false).then((retrieved_events:any[]) => {
		  this.notificationAmount = retrieved_events.length;
		});
	}


	startSearch() {
		this.analyticsService.trackEvent('startSearch');
	}
}
